import React, { useRef, useState } from 'react'
import PostComposer from '@/components/feed/PostComposer'
import FeedList from '@/components/feed/FeedList'
import FeedSidebar from '@/components/feed/FeedSidebar'
import { PageContainer } from '@/components/layout/PageContainer'
import { SplitLayout } from '@/components/layout/SplitLayout'
import { PostVisibility } from '@/types/feed'
import type { IPost } from '@/types/feed'

const FeedPage: React.FC = () => {
  const [visibility, setVisibility] = useState<PostVisibility | undefined>(undefined)
  const prependRef = useRef<((post: IPost) => void) | null>(null)

  return (
    <PageContainer>
      <h1 className="mb-4 text-xl font-semibold text-gray-900">Feed</h1>

      <SplitLayout
        main={
          <>
            <div className="mb-4">
              <PostComposer onCreated={(post) => prependRef.current?.(post)} />
            </div>

            <FeedList
              {...(visibility && { visibility })}
              registerPrepend={(fn) => {
                prependRef.current = fn
              }}
            />
          </>
        }
        sidebar={<FeedSidebar visibility={visibility} onChange={setVisibility} />}
      />
    </PageContainer>
  )
}

export default FeedPage
